export default "__VITE_ASSET__98d4ca9b__"